// extracted by mini-css-extract-plugin
module.exports = {"customSlideOptionsContainer":"CampaignTemplatesPage_customSlideOptionsContainer__q2LZP"};